// extracted by mini-css-extract-plugin
export default {"storyDetailAdvertAvatar":"c-r_hg","storyDetailAdvertAvatar__image":"c-r_hh"};